<h4>Name & Location</h4>

<div [formGroup]="frmCustomerDetails">
  <section class="field-group">
    <div class="field-holder w2">
      <mat-radio-group 
        class="customer-type-group" 
        formControlName="customerType" 
        aria-label="Select an option" 
        (change)="customerTyperadioChanges($event)">
          <mat-radio-button class="customer-type-radio-button" *ngFor="let customerType of customerTypes" [value]="customerType.value">
            {{customerType.name}}
          </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="field-holder w2">
      <mat-radio-group 
        class="customer-type-size-group" 
        *ngIf="customerIsCommercial" 
        formControlName="customerTypeSize" 
        aria-label="Select an option" 
        (change)="customerTypeSizeradioChanges($event)">
          <mat-radio-button class="customer-type-size-radio-button" *ngFor="let customerTypeSize of customerTypeSizes" [value]="customerTypeSize.value">
            {{customerTypeSize.name}}
          </mat-radio-button>
          <mat-error *ngIf="frmCustomerDetails.get('customerTypeSize')?.errors?.required">Please select a Customer Type Size</mat-error>
      </mat-radio-group>
    </div>
  </section>

  <section class="field-group">
    <div class="field-holder w2" *ngIf="(this.customerType$ | async) === customerType.Commercial">
      <mat-form-field appearance="standard">
        <mat-label>Company Name</mat-label>
        <input id="companyName" matInput maxlength="255" type="text" formControlName="organisationName" (focusout)="changeFormData()" />
        <mat-error *ngIf="frmCustomerDetails.get('organisationName')?.errors?.requiredWhen"> Please enter a Company Name</mat-error>
        <mat-error *ngIf="frmCustomerDetails.get('organisationName')?.errors?.maxlength"> Company Name cannot exceed 255 characters</mat-error>
      </mat-form-field>
    </div>

    <div
      class="field-holder w2 person-name-container"
      formGroupName="customerName"
      *ngIf="(this.customerType$ | async) === customerType.Residential"
    >
      <mat-form-field appearance="standard">
        <mat-label>Customer First Name</mat-label>
        <input id="customerTitle" matInput maxlength="255" type="text" formControlName="customerFirstName" (focusout)="changeFormData()"/>
        <mat-error *ngIf="frmCustomerDetails.get('customerName.customerFirstName')?.errors?.requiredWhen"> Please enter a Customer First Name</mat-error>
        <mat-error *ngIf="frmCustomerDetails.get('customerName.customerFirstName')?.errors?.maxlength">
          Customer First Name cannot exceed 100 characters
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="standard">
        <mat-label>Customer Last Name</mat-label>
        <input id="customerTitle" matInput maxlength="255" type="text" formControlName="customerLastName" (focusout)="changeFormData()"/>
        <mat-error *ngIf="frmCustomerDetails.get('customerName.customerLastName')?.errors?.requiredWhen"> Please enter a Customer Last Name</mat-error>
        <mat-error *ngIf="frmCustomerDetails.get('customerName.customerLastName')?.errors?.maxlength">
          Customer Last Name cannot exceed 100 characters
        </mat-error>
      </mat-form-field>
    </div>
  </section>

  <div class="zip-search-container">
    <app-zip-lookup
      formGroupName="location"
      (formInitialised)="zipLookupInitialised($event)"
      (addressFound)="addressFound($event)"
      >
    </app-zip-lookup>
    <button
      *ngIf="frmCustomerDetails?.get('customerType')?.value === customerType.Commercial && dunsLookupEnabled"
      mat-flat-button
      color="accent"
      (click)="searchCompany()"
      [disabled]="!validForLookup()"
    >
      <img class="prefix" src="/assets/icons/icon-search.svg" />
      Search
    </button>
  </div>
  <div>
    <mat-checkbox id="taxExemptCheckbox" color="primary" formControlName="isTaxExempt" (focusout)="changeFormData()">
      <span id="checkboxText">Tax Exempt</span>
    </mat-checkbox>
  </div>
</div>


